import { render, staticRenderFns } from "./InlineMenu.vue?vue&type=template&id=9c4c47cc&scoped=true"
import script from "./InlineMenu.vue?vue&type=script&lang=js"
export * from "./InlineMenu.vue?vue&type=script&lang=js"
import style0 from "./InlineMenu.vue?vue&type=style&index=0&id=9c4c47cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4c47cc",
  null
  
)

export default component.exports